<template>
    <div class="content">
        <div class="d-flex justify-content-center align-items-center" v-if="isProfitOnly">
            <div class="target">
                Profit Income
                <div v-if="isLoading" class="loading">
                    <i class="el-icon-loading"></i>
                </div>
                <span v-else class="d-block">
                    {{ profitIncome }}
                </span>
                
                
            </div>
        </div>

        <div class="d-flex justify-content-between align-items-center" v-if="!isProfitOnly && info != null">
            <div class="target">
                {{ info.targetLabel }}
                <div v-if="isLoading" class="loading">
                    <i class="el-icon-loading"></i>
                </div>
                <span v-else class="d-block">
                    {{ info.target }}
                </span>
            </div>

            <div class="separator"></div>

            <div class="actual">
                {{ info.actualLabel }}
                <div v-if="isLoading" class="loading">
                    <i class="el-icon-loading"></i>
                </div>
                <span v-else class="d-block">
                    {{ info.actual }}
                </span>
            </div>

            <div class="separator" v-if="isWeekly"></div>

            <div class="variance" :class="{'warning' : info.isWarning}" v-if="isWeekly">
                {{ info.varianceLabel }}
                <div v-if="isLoading" class="loading">
                    <i class="el-icon-loading"></i>
                </div>
                <span v-else class="d-block">
                    {{ info.variance }}
                </span>
            </div>
        </div>


    </div>
</template>

<style lang='scss'>
@import "static/scss/fonts/fonts";
@import "static/scss/colors";
    .loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 1rem;
        > span {
            @include montserrat-font(24px, normal, 500, $white);
        }

        i {
            color: var(--text-color);
            font-size: 20px;
        }
    }
    .content {
        .target, .actual, .variance {
            @include montserrat-font(16px, normal, 500, $white) {
                padding: 6px 1rem;
                text-align: center;
                width: 100%;
            }

            > span {
                font-size: 24px;
                line-height: 120%;
                font-weight: 600;
                margin-top: 4px;
            }
        }

        .actual {
            color: $blue1;
        }


        .variance {
            color: $green;

            &.warning {
                color: $red;
            }
        }

        .separator {
            background-color: $gray4;
            height: 50px;
            width: 1px;
        }
    }
</style>

<script>

    export default {
        data() {
            return {
            }
        },
        props: {
            isLoading: {
                default: false,
            },
            info: {
                default: null
            },
            isWeekly: {
                default: false  
            },
            isProfitOnly: {
                default: false 
            },
            profitIncome: {
                default: 0.00
            },
        },
        watch: {
            
        },
        computed: {
            
        },
        methods: {
            
        },
        mounted() {
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/card/venue/venueContent.vue